module.exports = __webpack_public_path__ + "static/img/wangping.ff830a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mingpian/wangping.png
// module id = w9r/
// module chunks = 0